/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
// import { IContentBlockViewProps } from '@msdyn365-commerce-modules/content-block';
import { IWriteReviewViewProps, IReviewModalViewProps } from '@msdyn365-commerce-modules/ratings-reviews';
import { Module, Node, IModuleProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

const ContentBlockView: React.FC<IWriteReviewViewProps> = props => {
    const { heading, /* signInMessage, */ signInButton, modalToggle, reviewModal, moduleProps } = props;
    const isAuthenticated = props.context.request.user.isAuthenticated;
    // @ts-ignore
    //const reviewButtonLabel = moduleProps?.moduleProps?.resources?.reviewButtonLabel ?? '';
    //const customSignInButton = signInButton;
    // @ts-ignore
    //customSignInButton.props.text = reviewButtonLabel;
    // const test = { ...moduleProps };
    // @ts-ignore
    moduleProps.moduleProps.resources.signInLabel = moduleProps.moduleProps.resources.reviewButtonLabel;
    React.useEffect(() => {
        const button = document.getElementsByClassName('ms-write-review__sign-in-btn')[0];
        if (button) {
            button.setAttribute('style', 'visibility: visible');
        }
    }, []);
    return React.createElement(
        Module,
        Object.assign({}, moduleProps),
        heading,
        !isAuthenticated
            ? React.createElement(React.Fragment, null, null, signInButton)
            : React.createElement(React.Fragment, null, modalToggle, createReviewModal(reviewModal, moduleProps))
    );
    /* return (React.createElement(Module, Object.assign({}, moduleProps),
        heading,
        !isAuthenticated ? React.createElement(React.Fragment, null,
            signInMessage,
            signInButton) : React.createElement(React.Fragment, null,
            modalToggle,
            createReviewModal(reviewModal, moduleProps)))); */
};
const createReviewModal = (props: IReviewModalViewProps, moduleProps: IModuleProps) => {
    return React.createElement(
        Module,
        Object.assign({}, props.modal, moduleProps),
        props.modalHeader,
        React.createElement(
            Node,
            Object.assign({}, props.modalBody),
            React.createElement(
                Node,
                Object.assign({}, props.form),
                React.createElement(Node, Object.assign({}, props.inputRow), props.rating, props.ratingLabel),
                React.createElement(Node, Object.assign({}, props.inputRow), props.titleLabel, props.titleInput),
                React.createElement(Node, Object.assign({}, props.inputRow), props.textLabel, props.textInput),
                props.privacyPolicyUrl,
                props.error
            )
        ),
        React.createElement(Node, Object.assign({}, props.modalFooter), props.submitButton, props.cancelButton)
    );
};
export default ContentBlockView;
